import React__default from 'react';
import { E as ErrorBoundary } from './vendor-1535a03e.js';
import { createUseStyles } from 'react-jss';
import { defineMessages, t } from '@sm/intl';
const useStyles$1 = createUseStyles(theme => ({
  wdsIcons: ({
    color,
    size
  }) => {
    var _a, _b, _c;
    const fontSize = size ? {
      fontSize: theme.iconSize[size]
    } : {
      fontSize: 'inherit'
    };
    const chosenColor =
    // @ts-expect-error Fallback styles are acceptable
    ((_a = theme.palette) === null || _a === void 0 ? void 0 : _a.text[color]) || ((_c = (_b = theme.palette) === null || _b === void 0 ? void 0 : _b[color]) === null || _c === void 0 ? void 0 : _c.main) || 'currentColor';
    return {
      ...fontSize,
      width: '1em',
      height: '1em',
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'center',
      fill: chosenColor
    };
  }
}));

// https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
const getDisplayName = Component => Component.displayName || Component.name || 'Component';
function withIcon(Component) {
  function WithIcon({
    color,
    title,
    size,
    ...rest
  }) {
    const classes = useStyles$1({
      color,
      size
    });
    return React__default.createElement("svg", {
      className: classes.wdsIcons,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "xMidYMid",
      "aria-label": title,
      role: title ? 'img' : 'presentation',
      ...rest
    }, React__default.createElement(Component, null));
  }
  WithIcon.displayName = `WithIcon(${getDisplayName(Component)})`;
  WithIcon.getOriginalComponent = () => Component;
  return WithIcon;
}
createUseStyles({
  svgContainer: {
    display: 'inline-block',
    width: '1em',
    height: '1em'
  }
});
function DocumentXIconPath() {
  return React__default.createElement("path", {
    d: "m5.94.005 8.012.012C14.53.018 15 .487 15 1.067V14.95c0 .58-.47 1.05-1.05 1.05H2.05C1.47 16 1 15.53 1 14.95V4.94L5.94.004zM7 1.505V4.95c0 .541-.41.987-.936 1.044L5.95 6H2.5v8.5h11V1.514L7 1.505zM6.557 7.53 8 8.973 9.443 7.53a.765.765 0 0 1 1.083 1.082l-1.444 1.443 1.444 1.444a.765.765 0 0 1-1.083 1.082L8 11.138 6.557 12.58A.765.765 0 1 1 5.474 11.5l1.444-1.444-1.444-1.443A.765.765 0 1 1 6.557 7.53zM5.5 2.563 3.561 4.5H5.5V2.562z"
  });
}
var IconDocumentX = withIcon(DocumentXIconPath);
const useStyles = createUseStyles(theme => {
  var _a, _b;
  return {
    fallbackComponent: {
      fontFamily: (_b = (_a = theme.questionBody) === null || _a === void 0 ? void 0 : _a.fontFamily) !== null && _b !== void 0 ? _b : {},
      color: theme.questionColor,
      border: `1px solid ${theme.questionColor}`,
      borderRadius: '5px',
      width: '100%',
      height: '100%',
      minHeight: '220px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& svg': {
        fill: theme.questionColor
      }
    },
    errorMessage: {
      marginLeft: `8px` // equivalent to wrench theme.spacing[2]
    }
  };
});

const COPY = defineMessages({
  ERROR: {
    id: 'FallbackComponent.ERROR',
    defaultMessage: 'Error loading question',
    description: '[Type: label][Vis: high] - error message indicating a question could not be loaded'
  }
});
function FallbackComponent() {
  const {
    fallbackComponent,
    errorMessage
  } = useStyles();
  return React__default.createElement("div", {
    className: fallbackComponent
  }, React__default.createElement(IconDocumentX, null), React__default.createElement("p", {
    className: errorMessage
  }, t(COPY.ERROR)));
}
const withErrorBoundary = Component => {
  const displayName = Component.displayName || Component.name || 'Component';
  function ComponentWithErrorBoundary(props) {
    return React__default.createElement(ErrorBoundary, {
      FallbackComponent: FallbackComponent
    }, React__default.createElement(Component, {
      ...props
    }));
  }
  ComponentWithErrorBoundary.displayName = `withErrorBoundary(${displayName})`;
  return ComponentWithErrorBoundary;
};
export { FallbackComponent, withErrorBoundary };